import JSONbigInt from "json-bigint";

type Parse = (
  text: string,
  reviver?: (this: any, key: string, value: any) => any
) => any;
type Stringify = (
  value: any,
  replacer?: (this: any, key: string, value: any) => any,
  space?: string | number
) => string;

const { parse: bigParse, stringify: bigStringify } = JSONbigInt({
  useNativeBigInt: true,
});

const parse: Parse = (...args) => {
  try {
    return bigParse(...args);
  } catch (e) {
    console.error(e);
    return JSON.parse(...args);
  }
};

const stringify: Stringify = (...args) => {
  try {
    return bigStringify(...args);
  } catch (e) {
    console.error(e);
    return JSON.stringify(...args);
  }
};

/**
 * This is a `JSON` implementation that allows for
 * parsing and stringifying values above `Number.MAX_SAFE_INTEGER`.
 * @example
 * // JSON.parse(data) // Nope!
 * JSONbig.parse(data)
 * @example
 * const response = await fetch(endpoint)
 * // const obj = await response.json() // Nope!
 * const obj = JSONbig.parse(await response.text())
 */
export const JSONbig = {
  parse,
  stringify,
};
